export const gridViewConnectorHeaderType = Object.freeze({
	Parent: 0,
	Child: 1,
});
